import { Box, useTheme } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { Button } from '@mui/material'
import { tokens } from '../../theme'
import Header from '../../components/Header'
import React from "react"
import { useState, useEffect } from "react"
import { ptBR as ptBRGrid } from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'

import * as Constants from '../../constants'

const Owners = () => {
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)

  const [rows, setRows] = useState([])

  const fetchOwners = () => {
    fetch(Constants.HOST + '/owners', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            data = data.data
            let newRows = []
            if (typeof data.owners === 'object') {
              data.owners.forEach((owner) => {
                newRows.push({
                  id: owner.id,
                  name: owner.name,
                })
              })
            }

            setRows(newRows)
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    fetchOwners()
  }, [])

  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    {
      field: 'name',
      headerName: 'Nome',
      flex: 1,
      cellClassName: 'name-column--cell',
    },
    {
      field: 'actions',
      headerName: '',
      flex: 1,
      renderCell: ({ row: { id } }) => {
        return (
          <Box display="flex" justifyContent="right">
            <Button
              variant="contained"
              sx={{ mr: '5px' }}
              onClick={() =>
                navigate(`/edit-owner/${rows.find((row) => row.id === id).id}`)
              }
            >
              {' '}
              Editar{' '}
            </Button>
            <Button
              variant="contained"
              onClick={() => navigate(`/del-owner/${id}`)}
            >
              {' '}
              Excluir{' '}
            </Button>
          </Box>
        )
      },
    },
  ]

  let navigate = useNavigate()
  const handleAddUser = () => {
    navigate('/add-owner')
  }

  return (
    <Box m="20px">
      <Box mb="20px" display="flex" justifyContent="space-between">
        <Box display="grid" gridColumn="span 6" justifyContent="space-between">
          <Header title="Proprietários" />
        </Box>
        <Box
          m="20px 0"
          display="grid"
          gridColumn="span 6"
          justifyContent="flex-end"
        >
          <Button variant="contained" color="success" onClick={handleAddUser}>
            Adicionar proprietário
          </Button>
        </Box>
      </Box>
      <Box
        m="20px 0 0 0"
        height="75vh"
        sx={{
          '& .MuiDataGrid-root': {
            border: 'none',
          },
          '& .MuiDataGrid-cell': {
            borderBottom: 'none',
          },
          '& .name-column--cell': {
            color: colors.greenAccent[300],
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: colors.blueAccent[700],
            borderBottom: 'none',
          },
          '& .MuiDataGrid-virtualScroller': {
            backgroundColor: colors.primary[400],
          },
          '& .MuiDataGrid-footerContainer': {
            borderTop: 'none',
            backgroundColor: colors.blueAccent[700],
          },
          '& .MuiCheckbox-root': {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          localeText={ptBRGrid.components.MuiDataGrid.defaultProps.localeText}
        />
      </Box>
    </Box>
  )
}

export default Owners 
